import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/UserConfiguration.css';
import ModalDialog from '../ModalDialog';
import BiddingItem from './BiddingItem';
import ReadonlyField from '../fields/ReadonlyField';
import useAuthentication from '../../hooks/useAuthentication';
import {
    getUserIdFromToken,
    getUserNameFromToken,
} from '../../utils/authentication';
import RevokeDevicesButton from "../buttons/RevokeDevicesButton";
import useExtendedMutation from "../../hooks/useExtendedMutation";
import { REVOKE_TRUSTED_DEVICES } from "../../graphql/userConfiguration";
import { getTrustedDeviceUserConfiguration } from "../../reducers";
import { updateTrustedDeviceUserConfiguration } from "../../actions/userConfiguration";

UserConfiguration.propTypes = {
    onCancel: PropTypes.func.isRequired,
};

function UserConfiguration(props) {
    const dispatch = useDispatch();
    const {
        onCancel,
    } = props;
    const { t } = useTranslation();
    const { accessToken } = useAuthentication();
    const { hasTrustedDevice } = useSelector(getTrustedDeviceUserConfiguration);
    const revokeAllTrustedDevices = useExtendedMutation(REVOKE_TRUSTED_DEVICES,
        {
            successCallback: () => dispatch(updateTrustedDeviceUserConfiguration(false)),
            successMessageOptions: {
                key: 'user-configuration.trusted-device.notification.update-success',
                dataProperty: 'updateTrustedDevicesUserConfiguration'
            },
            failureMessageOptions: { key: 'user-configuration.trusted-device.notification.update-failure' },
        });
    return (
        <ModalDialog onCancel={onCancel}>
            <div className="user-configuration-popup-dialog" role="dialog" aria-modal>
                <div className="user-configuration-popup-dialog--header">
                    <h4><FontAwesomeIcon icon="user-cog" />&nbsp;{t('user-configuration.title')}</h4>
                    <button
                        type="button"
                        className="close-button button-small button-primary-text user-configuration-popup-dialog--close"
                        onClick={onCancel}
                    >
                        <span aria-label={t('button.x')} title={t('button.x')} role="img">
                            <FontAwesomeIcon icon="times" />
                        </span>
                    </button>
                </div>
                <div className="user-configuration-popup--header-panel">
                    <ReadonlyField
                        label={t('user-configuration.name')}
                        value={getUserNameFromToken(accessToken)}
                        className="user-configuration-popup--header-panel--name"
                    />
                    <ReadonlyField
                        label={t('user-configuration.user-id')}
                        value={getUserIdFromToken(accessToken)}
                        className="user-configuration-popup--header-panel--user-id"
                    />
                    <div>
                        <RevokeDevicesButton
                            extendedMutation={revokeAllTrustedDevices}
                            disabled={!hasTrustedDevice}
                            label={t('user-configuration.trusted-device.revoke-all-button')}
                            confirmationMessage={t('user-configuration.trusted-device.notification.update-success')}
                        />
                    </div>
                </div>
                <div className="user-configuration-popup-dialog--content">
                    <BiddingItem />
                </div>
            </div>
        </ModalDialog>
    );
}

export default UserConfiguration;
